// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__1azLS","form":"styles_form__34EUA","inputs":"styles_inputs__3qPN_","buttons":"styles_buttons__1uVE9"};